import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { BrowserRouter } from "react-router-dom";
import { createAppTheme } from "./theme/Theme";
import { SoundProvider } from "./context/SoundContext";
import { ThemeContextProvider, useThemeContext } from "./context/ThemeContext";

/* ── Easter egg ── */
const G = "#00e676";
const D = "#0d1b2a";
console.log(
  "%c" +
  " █████  █████   ████  █████ \n" +
  " █      █   █      █  █   █ \n" +
  " ████   █████    █    █████ \n" +
  " █      █   █   █     █   █ \n" +
  " █      █   █  █████  █   █ \n",
  `color:${G}; font-family:monospace; font-size:13px; line-height:1.6;`
);
console.log(
  "%c Muhammad Faza Hardiansyah %c Front-End Developer ",
  `background:${G}; color:${D}; font-weight:700; padding:3px 8px; border-radius:4px 0 0 4px;`,
  `background:${D}; color:${G}; font-weight:600; padding:3px 8px; border-radius:0 4px 4px 0; border:1px solid ${G};`
);
console.log(
  "%c 📬  fazamhdh95@gmail.com",
  `color:${G}; font-size:12px; margin-top:4px;`
);
console.log(
  "%c 🛠   React · Next.js · TypeScript · Material-UI · Redux Toolkit · GraphQL",
  "color:gray; font-size:11px;"
);
console.log(
  "%c 👀  Psst — you found the easter egg. Let's build something great together!",
  "color:gray; font-size:11px; font-style:italic;"
);

const DynamicThemeProvider = ({ children }) => {
  const { isDark } = useThemeContext();
  return (
    <ThemeProvider theme={createAppTheme(isDark)}>
      {children}
    </ThemeProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeContextProvider>
        <DynamicThemeProvider>
          <SoundProvider>
            <CssBaseline />
            <link
              href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap"
              rel="stylesheet"
            />
            <a href="#main-content" className="skip-link">
              Skip to main content
            </a>
            <App />
          </SoundProvider>
        </DynamicThemeProvider>
      </ThemeContextProvider>
    </BrowserRouter>
  </React.StrictMode>
);
